import { gql } from '__generated__';

export default gql(`
  query GetGeneratedPracticalInfoDescription($project_id: ID!, $input: GeneratePracticalInfoDescriptionInput!) {
    project(id: $project_id) {
      id
      generated_practical_info_description(input: $input) {
        description
      }
    }
  }
`);
